const streetTypeMapping = [
  {
    Abbreviation: 'ACCS',
    StreetType: 'Access',
  },
  {
    Abbreviation: 'ALLY',
    StreetType: 'Alley',
  },
  {
    Abbreviation: 'ALWY',
    StreetType: 'Alleyway',
  },
  {
    Abbreviation: 'AMBL',
    StreetType: 'Amble',
  },
  {
    Abbreviation: 'ANCG',
    StreetType: 'Anchorage',
  },
  {
    Abbreviation: 'APP',
    StreetType: 'Approach',
  },
  {
    Abbreviation: 'ARC',
    StreetType: 'Arcade',
  },
  {
    Abbreviation: 'ART',
    StreetType: 'Artery',
  },
  {
    Abbreviation: 'AVE',
    StreetType: 'Avenue',
  },
  {
    Abbreviation: 'BASN',
    StreetType: 'Basin',
  },
  {
    Abbreviation: 'BCH',
    StreetType: 'Beach',
  },
  {
    Abbreviation: 'BEND',
    StreetType: 'Bend',
  },
  {
    Abbreviation: 'BLK',
    StreetType: 'Block',
  },
  {
    Abbreviation: 'BVD',
    StreetType: 'Boulevard',
  },
  {
    Abbreviation: 'BRCE',
    StreetType: 'Brace',
  },
  {
    Abbreviation: 'BRAE',
    StreetType: 'Brae',
  },
  {
    Abbreviation: 'BRK',
    StreetType: 'Break',
  },
  {
    Abbreviation: 'BDGE',
    StreetType: 'Bridge',
  },
  {
    Abbreviation: 'BDWY',
    StreetType: 'Broadway',
  },
  {
    Abbreviation: 'BROW',
    StreetType: 'Brow',
  },
  {
    Abbreviation: 'BYPA',
    StreetType: 'Bypass',
  },
  {
    Abbreviation: 'BYWY',
    StreetType: 'Byway',
  },
  {
    Abbreviation: 'CAUS',
    StreetType: 'Causeway',
  },
  {
    Abbreviation: 'CN',
    StreetType: 'Central',
  },
  {
    Abbreviation: 'CTR',
    StreetType: 'Centre',
  },
  {
    Abbreviation: 'CNWY',
    StreetType: 'Centreway',
  },
  {
    Abbreviation: 'CH',
    StreetType: 'Chase',
  },
  {
    Abbreviation: 'CIR',
    StreetType: 'Circle',
  },
  {
    Abbreviation: 'CLT',
    StreetType: 'Circlet',
  },
  {
    Abbreviation: 'CCT',
    StreetType: 'Circuit',
  },
  {
    Abbreviation: 'CRCS',
    StreetType: 'Circus',
  },
  {
    Abbreviation: 'CL',
    StreetType: 'Close',
  },
  {
    Abbreviation: 'CLDE',
    StreetType: 'Colonnade',
  },
  {
    Abbreviation: 'CMMN',
    StreetType: 'Common',
  },
  {
    Abbreviation: 'CON',
    StreetType: 'Concourse',
  },
  {
    Abbreviation: 'CPS',
    StreetType: 'Copse',
  },
  {
    Abbreviation: 'CNR',
    StreetType: 'Corner',
  },
  {
    Abbreviation: 'CSO',
    StreetType: 'Corso',
  },
  {
    Abbreviation: 'CT',
    StreetType: 'Court',
  },
  {
    Abbreviation: 'CTYD',
    StreetType: 'Courtyard',
  },
  {
    Abbreviation: 'COVE',
    StreetType: 'Cove',
  },
  {
    Abbreviation: 'CRES',
    StreetType: 'Crescent',
  },
  {
    Abbreviation: 'CRST',
    StreetType: 'Crest',
  },
  {
    Abbreviation: 'CRSS',
    StreetType: 'Cross',
  },
  {
    Abbreviation: 'CRSG',
    StreetType: 'Crossing',
  },
  {
    Abbreviation: 'CRD',
    StreetType: 'Crossroad',
  },
  {
    Abbreviation: 'COWY',
    StreetType: 'Crossway',
  },
  {
    Abbreviation: 'CUWY',
    StreetType: 'Cruiseway',
  },
  {
    Abbreviation: 'CDS',
    StreetType: 'Cul-de-sac',
  },
  {
    Abbreviation: 'CTTG',
    StreetType: 'Cutting',
  },
  {
    Abbreviation: 'DALE',
    StreetType: 'Dale',
  },
  {
    Abbreviation: 'DELL',
    StreetType: 'Dell',
  },
  {
    Abbreviation: 'DEVN',
    StreetType: 'Deviation',
  },
  {
    Abbreviation: 'DIP',
    StreetType: 'Dip',
  },
  {
    Abbreviation: 'DSTR',
    StreetType: 'Distributor',
  },
  {
    Abbreviation: 'DR',
    StreetType: 'Drive',
  },
  {
    Abbreviation: 'DRWY',
    StreetType: 'Driveway',
  },
  {
    Abbreviation: 'E',
    StreetType: 'East',
  },
  {
    Abbreviation: 'EDGE',
    StreetType: 'Edge',
  },
  {
    Abbreviation: 'ELB',
    StreetType: 'Elbow',
  },
  {
    Abbreviation: 'END',
    StreetType: 'End',
  },
  {
    Abbreviation: 'ENT',
    StreetType: 'Entrance',
  },
  {
    Abbreviation: 'ESP',
    StreetType: 'Esplanade',
  },
  {
    Abbreviation: 'EST',
    StreetType: 'Estate',
  },
  {
    Abbreviation: 'EXP',
    StreetType: 'Expressway',
  },
  {
    Abbreviation: 'EXTN',
    StreetType: 'Extension',
  },
  {
    Abbreviation: 'EX',
    StreetType: 'Extension',
  },
  {
    Abbreviation: 'FAWY',
    StreetType: 'Fairway',
  },
  {
    Abbreviation: 'FTRK',
    StreetType: 'Fire Track',
  },
  {
    Abbreviation: 'FITR',
    StreetType: 'Firetrail',
  },
  {
    Abbreviation: 'FLAT',
    StreetType: 'Flat',
  },
  {
    Abbreviation: 'FOLW',
    StreetType: 'Follow',
  },
  {
    Abbreviation: 'FTWY',
    StreetType: 'Footway',
  },
  {
    Abbreviation: 'FSHR',
    StreetType: 'Foreshore',
  },
  {
    Abbreviation: 'FORM',
    StreetType: 'Formation',
  },
  {
    Abbreviation: 'FWY',
    StreetType: 'Freeway',
  },
  {
    Abbreviation: 'FRNT',
    StreetType: 'Front',
  },
  {
    Abbreviation: 'FRTG',
    StreetType: 'Frontage',
  },
  {
    Abbreviation: 'GAP',
    StreetType: 'Gap',
  },
  {
    Abbreviation: 'GDN',
    StreetType: 'Garden',
  },
  {
    Abbreviation: 'GDNS',
    StreetType: 'Gardens',
  },
  {
    Abbreviation: 'GTE',
    StreetType: 'Gate',
  },
  {
    Abbreviation: 'GTES',
    StreetType: 'Gates',
  },
  {
    Abbreviation: 'GLD',
    StreetType: 'Glade',
  },
  {
    Abbreviation: 'GLEN',
    StreetType: 'Glen',
  },
  {
    Abbreviation: 'GRA',
    StreetType: 'Grange',
  },
  {
    Abbreviation: 'GRN',
    StreetType: 'Green',
  },
  {
    Abbreviation: 'GRND',
    StreetType: 'Ground',
  },
  {
    Abbreviation: 'GR',
    StreetType: 'Grove',
  },
  {
    Abbreviation: 'GLY',
    StreetType: 'Gully',
  },
  {
    Abbreviation: 'HTS',
    StreetType: 'Heights',
  },
  {
    Abbreviation: 'HRD',
    StreetType: 'Highroad',
  },
  {
    Abbreviation: 'HWY',
    StreetType: 'Highway',
  },
  {
    Abbreviation: 'HILL',
    StreetType: 'Hill',
  },
  {
    Abbreviation: 'INTG',
    StreetType: 'Interchange',
  },
  {
    Abbreviation: 'INTN',
    StreetType: 'Intersection',
  },
  {
    Abbreviation: 'JNC',
    StreetType: 'Junction',
  },
  {
    Abbreviation: 'KEY',
    StreetType: 'Key',
  },
  {
    Abbreviation: 'LDG',
    StreetType: 'Landing',
  },
  {
    Abbreviation: 'LANE',
    StreetType: 'Lane',
  },
  {
    Abbreviation: 'LNWY',
    StreetType: 'Laneway',
  },
  {
    Abbreviation: 'LEES',
    StreetType: 'Lees',
  },
  {
    Abbreviation: 'LINE',
    StreetType: 'Line',
  },
  {
    Abbreviation: 'LINK',
    StreetType: 'Link',
  },
  {
    Abbreviation: 'LT',
    StreetType: 'Little',
  },
  {
    Abbreviation: 'LKT',
    StreetType: 'Lookout',
  },
  {
    Abbreviation: 'LOOP',
    StreetType: 'Loop',
  },
  {
    Abbreviation: 'LWR',
    StreetType: 'Lower',
  },
  {
    Abbreviation: 'LR',
    StreetType: 'Lower',
  },
  {
    Abbreviation: 'MALL',
    StreetType: 'Mall',
  },
  {
    Abbreviation: 'MNDR',
    StreetType: 'Meander',
  },
  {
    Abbreviation: 'MEW',
    StreetType: 'Mew',
  },
  {
    Abbreviation: 'MEWS',
    StreetType: 'Mews',
  },
  {
    Abbreviation: 'MWY',
    StreetType: 'Motorway',
  },
  {
    Abbreviation: 'MT',
    StreetType: 'Mount',
  },
  {
    Abbreviation: 'NOOK',
    StreetType: 'Nook',
  },
  {
    Abbreviation: 'N',
    StreetType: 'North',
  },
  {
    Abbreviation: 'NE',
    StreetType: 'North East',
  },
  {
    Abbreviation: 'NW',
    StreetType: 'North West',
  },
  {
    Abbreviation: 'OTLK',
    StreetType: 'Outlook',
  },
  {
    Abbreviation: 'PDE',
    StreetType: 'Parade',
  },
  {
    Abbreviation: 'PARK',
    StreetType: 'Park',
  },
  {
    Abbreviation: 'PKLD',
    StreetType: 'Parklands',
  },
  {
    Abbreviation: 'PKWY',
    StreetType: 'Parkway',
  },
  {
    Abbreviation: 'PART',
    StreetType: 'Part',
  },
  {
    Abbreviation: 'PASS',
    StreetType: 'Pass',
  },
  {
    Abbreviation: 'PATH',
    StreetType: 'Path',
  },
  {
    Abbreviation: 'PHWY',
    StreetType: 'Pathway',
  },
  {
    Abbreviation: 'PIAZ',
    StreetType: 'Piazza',
  },
  {
    Abbreviation: 'PL',
    StreetType: 'Place',
  },
  {
    Abbreviation: 'PLAT',
    StreetType: 'Plateau',
  },
  {
    Abbreviation: 'PLZA',
    StreetType: 'Plaza',
  },
  {
    Abbreviation: 'PKT',
    StreetType: 'Pocket',
  },
  {
    Abbreviation: 'PNT',
    StreetType: 'Point',
  },
  {
    Abbreviation: 'PORT',
    StreetType: 'Port',
  },
  {
    Abbreviation: 'PROM',
    StreetType: 'Promenade',
  },
  {
    Abbreviation: 'QUAD',
    StreetType: 'Quad',
  },
  {
    Abbreviation: 'QDGL',
    StreetType: 'Quadrangle',
  },
  {
    Abbreviation: 'QDRT',
    StreetType: 'Quadrant',
  },
  {
    Abbreviation: 'QY',
    StreetType: 'Quay',
  },
  {
    Abbreviation: 'QYS',
    StreetType: 'Quays',
  },
  {
    Abbreviation: 'RMBL',
    StreetType: 'Ramble',
  },
  {
    Abbreviation: 'RAMP',
    StreetType: 'Ramp',
  },
  {
    Abbreviation: 'RNGE',
    StreetType: 'Range',
  },
  {
    Abbreviation: 'RCH',
    StreetType: 'Reach',
  },
  {
    Abbreviation: 'RES',
    StreetType: 'Reserve',
  },
  {
    Abbreviation: 'REST',
    StreetType: 'Rest',
  },
  {
    Abbreviation: 'RTT',
    StreetType: 'Retreat',
  },
  {
    Abbreviation: 'RIDE',
    StreetType: 'Ride',
  },
  {
    Abbreviation: 'RDGE',
    StreetType: 'Ridge',
  },
  {
    Abbreviation: 'RGWY',
    StreetType: 'Ridgeway',
  },
  {
    Abbreviation: 'ROWY',
    StreetType: 'Right of Way',
  },
  {
    Abbreviation: 'RING',
    StreetType: 'Ring',
  },
  {
    Abbreviation: 'RISE',
    StreetType: 'Rise',
  },
  {
    Abbreviation: 'RVR',
    StreetType: 'River',
  },
  {
    Abbreviation: 'RVWY',
    StreetType: 'Riverway',
  },
  {
    Abbreviation: 'RVRA',
    StreetType: 'Riviera',
  },
  {
    Abbreviation: 'RD',
    StreetType: 'Road',
  },
  {
    Abbreviation: 'RDS',
    StreetType: 'Roads',
  },
  {
    Abbreviation: 'RDSD',
    StreetType: 'Roadside',
  },
  {
    Abbreviation: 'RDWY',
    StreetType: 'Roadway',
  },
  {
    Abbreviation: 'RNDE',
    StreetType: 'Ronde',
  },
  {
    Abbreviation: 'RSBL',
    StreetType: 'Rosebowl',
  },
  {
    Abbreviation: 'RTY',
    StreetType: 'Rotary',
  },
  {
    Abbreviation: 'RND',
    StreetType: 'Round',
  },
  {
    Abbreviation: 'RTE',
    StreetType: 'Route',
  },
  {
    Abbreviation: 'ROW',
    StreetType: 'Row',
  },
  {
    Abbreviation: 'RUE',
    StreetType: 'Rue',
  },
  {
    Abbreviation: 'RUN',
    StreetType: 'Run',
  },
  {
    Abbreviation: 'SWY',
    StreetType: 'Service Way',
  },
  {
    Abbreviation: 'SDNG',
    StreetType: 'Siding',
  },
  {
    Abbreviation: 'SLPE',
    StreetType: 'Slope',
  },
  {
    Abbreviation: 'SND',
    StreetType: 'Sound',
  },
  {
    Abbreviation: 'S',
    StreetType: 'South',
  },
  {
    Abbreviation: 'SE',
    StreetType: 'South East',
  },
  {
    Abbreviation: 'SW',
    StreetType: 'South West',
  },
  {
    Abbreviation: 'SPUR',
    StreetType: 'Spur',
  },
  {
    Abbreviation: 'SQ',
    StreetType: 'Square',
  },
  {
    Abbreviation: 'STRS',
    StreetType: 'Stairs',
  },
  {
    Abbreviation: 'SHWY',
    StreetType: 'State Highway',
  },
  {
    Abbreviation: 'STPS',
    StreetType: 'Steps',
  },
  {
    Abbreviation: 'STRA',
    StreetType: 'Strand',
  },
  {
    Abbreviation: 'ST',
    StreetType: 'Street',
  },
  {
    Abbreviation: 'STRP',
    StreetType: 'Strip',
  },
  {
    Abbreviation: 'SBWY',
    StreetType: 'Subway',
  },
  {
    Abbreviation: 'TARN',
    StreetType: 'Tarn',
  },
  {
    Abbreviation: 'TCE',
    StreetType: 'Terrace',
  },
  {
    Abbreviation: 'THOR',
    StreetType: 'Thoroughfare',
  },
  {
    Abbreviation: 'TLWY',
    StreetType: 'Tollway',
  },
  {
    Abbreviation: 'TOP',
    StreetType: 'Top',
  },
  {
    Abbreviation: 'TOR',
    StreetType: 'Tor',
  },
  {
    Abbreviation: 'TWRS',
    StreetType: 'Towers',
  },
  {
    Abbreviation: 'TRK',
    StreetType: 'Track',
  },
  {
    Abbreviation: 'TRL',
    StreetType: 'Trail',
  },
  {
    Abbreviation: 'TRLR',
    StreetType: 'Trailer',
  },
  {
    Abbreviation: 'TRI',
    StreetType: 'Triangle',
  },
  {
    Abbreviation: 'TKWY',
    StreetType: 'Trunkway',
  },
  {
    Abbreviation: 'TURN',
    StreetType: 'Turn',
  },
  {
    Abbreviation: 'UPAS',
    StreetType: 'Underpass',
  },
  {
    Abbreviation: 'UPR',
    StreetType: 'Upper',
  },
  {
    Abbreviation: 'UP',
    StreetType: 'Upper',
  },
  {
    Abbreviation: 'VALE',
    StreetType: 'Vale',
  },
  {
    Abbreviation: 'VDCT',
    StreetType: 'Viaduct',
  },
  {
    Abbreviation: 'VIEW',
    StreetType: 'View',
  },
  {
    Abbreviation: 'VLLS',
    StreetType: 'Villas',
  },
  {
    Abbreviation: 'VSTA',
    StreetType: 'Vista',
  },
  {
    Abbreviation: 'WADE',
    StreetType: 'Wade',
  },
  {
    Abbreviation: 'WALK',
    StreetType: 'Walk',
  },
  {
    Abbreviation: 'WKWY',
    StreetType: 'Walkway',
  },
  {
    Abbreviation: 'WAY',
    StreetType: 'Way',
  },
  {
    Abbreviation: 'W',
    StreetType: 'West',
  },
  {
    Abbreviation: 'WHRF',
    StreetType: 'Wharf',
  },
  {
    Abbreviation: 'WYND',
    StreetType: 'Wynd',
  },
  {
    Abbreviation: 'YARD',
    StreetType: 'Yard',
  },
]

export const getStreetTypeFromAbbreviation = (abbreviation: string) => {
  if (!abbreviation) return ''

  return (
    streetTypeMapping.find(mapping => mapping.Abbreviation === abbreviation)?.StreetType ??
    abbreviation
  )
}
